import { getMarket } from '../locale';
import getCurrentMapsAPIInstance from './getCurrentMapsAPIInstance';
const getPlaceSuggestions = ({ query, country, maxNumberOfResults = 5 }) => {
    const mapsAPIInstance = getCurrentMapsAPIInstance();
    if (!mapsAPIInstance) {
        throw new Error('Maps API is not initialized. Use `initializeMapsAPI` first.');
    }
    const defaultCountry = getMarket('lowerCase');
    const sessionToken = new google.maps.places.AutocompleteSessionToken();
    const autoCompleteRequestParams = {
        sessionToken,
        input: query,
        types: ['geocode'],
        componentRestrictions: {
            country: country || defaultCountry,
        },
    };
    return new Promise((resolve, reject) => {
        const mapsAutoCompleteService = new mapsAPIInstance.places.AutocompleteService();
        const { OK, ZERO_RESULTS } = mapsAPIInstance.places.PlacesServiceStatus;
        const handleAutoCompleteResponse = (placeSuggestions, placesServiceStatus) => {
            if (placesServiceStatus === ZERO_RESULTS) {
                resolve({ suggestions: [], sessionToken });
            }
            if (placesServiceStatus === OK) {
                const normalizedPlaceSuggestions = placeSuggestions
                    .splice(0, maxNumberOfResults)
                    .map((placeSuggestion) => {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    const { description, place_id, matched_substrings } = placeSuggestion;
                    return {
                        text: description,
                        id: place_id,
                        matchedStrings: matched_substrings,
                    };
                });
                resolve({ suggestions: normalizedPlaceSuggestions, sessionToken });
            }
            reject(placesServiceStatus);
        };
        mapsAutoCompleteService.getPlacePredictions(autoCompleteRequestParams, handleAutoCompleteResponse);
    });
};
export default getPlaceSuggestions;
//# sourceMappingURL=getPlaceSuggestions.js.map